import camelize from '@/tools/camelize';
import { dictionaryService, professionsService } from '@/services';
import { defaultLayoutService } from '../services';

const sortDesc = (a, b) => (a > b ? 1 : -1);
const sorter = (a, b, field = 'sort') =>
  b[field] === a[field] ? sortDesc(a.id, b.id) : sortDesc(a[field], b[field]);

const clearColorFromHash = (color) => color.replace(/#/gi, '');

const createActions = ({ $api }) => ({
  init({ dispatch, getters }) {
    const modules = dispatch('getApiModules').then((result) => {
      const list = [];
      if (getters.hasApiModuleSubordination)
        list.push(dispatch('getDepartments'));
      if (getters.hasApiModulePortfolio) {
        dispatch('getEducationLevel');
        dispatch('getEducationType');
      }
      if (getters.hasApiModuleConsultations) {
        dispatch('getUserConsultationsTopic');
      }
      if (getters.hasApiModulesMultiCop) {
        list.push(dispatch('copMultiRequest'));
      }
      if (getters.hasApiModulePortfolio) {
        list.push(
          dispatch('getDriverLicenseDict'),
          dispatch('getLanguageLevelDict'),
          dispatch('getWorldLanguageDict'),
          dispatch('getWorkScheduleDataDict'),
          dispatch('getEmploymentDict')
        );
      }
      if (getters.hasApiModulesNoko) {
        list.push(
          dispatch('getNokoCompetitionLevels'),
          dispatch('getNokoCompetitionList'),
          dispatch('getNokoCompetitionTypes'),
          dispatch('getNokoProgressResult')
        );
      }
      return list.length > 0 ? Promise.all(list) : result;
    });

    return Promise.all([
      dispatch('getDefaultLayout'),
      dispatch('getMunicipalities'),
      dispatch('getMunicipalityRegions'),
      dispatch('getRegionProfile'),
      dispatch('getSections'),
      dispatch('getOrganizators'),
      dispatch('getOrganizatorsFullList'),
      dispatch('getEducationForm'),
      dispatch('getEducationCategories'),
      dispatch('getUserEduLevel'),
      dispatch('getProfSpheres'),
      dispatch('getCompetences'),
      dispatch('orderCancelReasonDict'),
      dispatch('getProfessions'),
      dispatch('getProgrammTypes'),
      dispatch('getWorkTypes'),
      dispatch('getSpheresTypes'),
      dispatch('getProfStandarts'),
      dispatch('getWorkPlaces'),
      dispatch('getPayLevels'),
      dispatch('getEducationLevels'),
      dispatch('getIndastries'),
      // временное решение
      dispatch('getUnpublishedProfSpheres'),
      dispatch('getUnpublishedProfessions'),
      dispatch('getUnpublishedCompetences'),
      // конец решения
      dispatch('getModulesSections'),
      dispatch('getCompetencesList'),
      dispatch('getCompetencesBlocks'),
      // Мероприятия hasApiModuleActivity
      dispatch('getEducationFormActivity'), // формы обучения
      dispatch('getActivityMember'), // типы участия. мультисписок member
      dispatch('getActivityLevel'), // уровень мероприятия
      dispatch('getActivitySections'), // список для меню
      // Noko
      dispatch('getEventTypes'),
      dispatch('getRegionsDict'),
      dispatch('getEventTypesDict'),
      dispatch('getActivityOrderEduLevelDict'),
      dispatch('getEventOrderEduLevelsDict'),
      dispatch('getPartnerRoleDict'),
      dispatch('organizationsRequest'),
      modules,
    ]);
  },
  async getDefaultLayout({ commit }) {
    try {
      const { data: layoutConfig } = await defaultLayoutService.getConfig();
      const { data: layoutDataSet } = await defaultLayoutService.getDataSet();
      commit('setDefaultLayout', {
        config: layoutConfig || {},
        dataSet: layoutDataSet || [],
      });
    } catch (ex) {
      console.error(ex);
    }
  },
  getActivitySections({ commit }) {
    return $api
      .get('activity/sections/get')
      .then(({ data: { data } }) => {
        const sections = data
          .filter(({ activitiesAssigned }) => activitiesAssigned)
          .map((items) => ({
            ...items,
            children: items.children.filter(
              ({ activitiesAssigned }) => activitiesAssigned
            ),
          }));
        commit(
          'setActivitySections',
          data[0].activitiesAssigned ? sections : data
        );
      })
      .catch((err) => commit('setActivitySections', []));
  },

  getModulesSections({ commit }) {
    return $api
      .get('event-modules/sections/get')
      .then(({ data: { data } }) => {
        const sections = data
          .filter(({ modulesAssigned }) => modulesAssigned)
          .map((items) => ({
            ...items,
            children: items.children.filter(
              ({ modulesAssigned }) => modulesAssigned
            ),
          }));
        commit('setModulesSections', data[0].modulesAssigned ? sections : data);
      })
      .catch((err) => commit('setModulesSections', []));
  },

  getDepartments({ commit }) {
    return $api
      .get('departments/get')
      .then(({ data }) => commit('setDepartments', data.data))
      .catch((err) => commit('setDepartments', []));
  },

  getRegionProfile({ commit }) {
    return $api
      .get('region/profile/get')
      .then(({ data: { data } }) =>
        commit(
          'setRegionProfile',
          camelize({
            ...data,
            color_menu_main: clearColorFromHash(data.color_menu_main),
            color_menu_section: clearColorFromHash(data.color_menu_section),
            color_search: clearColorFromHash(data.color_search),
            color_btn_success: clearColorFromHash(data.color_btn_success),
          })
        )
      )
      .catch((err) => commit('setRegionProfile', {}));
  },

  getApiModules({ commit }) {
    return $api
      .get('modules/get')
      .then(({ data: { data } }) => {
        commit('setApiModules', data);
        return data;
      })
      .catch((err) => {
        const result = [];
        commit('setApiModules', result);
        return result;
      });
  },

  getSections({ commit }) {
    return $api
      .get('sections/get')
      .then(({ data: { data } }) => {
        const sections = data
          .filter(({ eventsAssigned }) => eventsAssigned)
          .map((items) => ({
            ...items,
            children: items.children.filter(
              ({ eventsAssigned }) => eventsAssigned
            ),
          }));
        commit(
          'setSections',
          data[0].eventsAssigned !== 'undefined' ? sections : data
        );
      })
      .catch((err) => commit('setSections', []));
  },

  getMunicipalities({ commit }) {
    return $api
      .get('municipalities/get')
      .then(({ data: { data } }) => {
        commit(
          'setMunicipalities',
          !Array.isArray(data)
            ? []
            : data
                .map((item) => ({
                  ...item,
                  sort:
                    parseInt(item.sort, 10) === 0
                      ? 99999
                      : parseInt(item.sort, 10),
                  id: parseInt(item.id, 10),
                }))
                .sort(sorter)
        );
      })
      .catch((err) => commit('setMunicipalities', []));
  },

  getMunicipalityRegions({ commit }) {
    return $api
      .get('municipality/regions/get')
      .then(({ data: { data } }) => {
        commit(
          'setMunicipalityRegions',
          !Array.isArray(data)
            ? []
            : data
                .map((item) => ({
                  ...item,
                  sort: parseInt(item.sort, 10),
                }))
                .sort(sorter)
        );
      })
      .catch((err) => commit('setMunicipalityRegions', []));
  },

  getRegions({ commit }) {
    return $api
      .get('regions/get')
      .then(({ data }) => {
        commit(
          'setRegions',
          !Array.isArray(data.data)
            ? []
            : data.data
                .map((item) => ({
                  ...item,
                  sort: item.importance,
                }))
                .sort(sorter)
        );
      })
      .catch((err) => commit('setRegions', []));
  },

  getOrganizators({ commit }) {
    return $api
      .get('organizations/get')
      .then(({ data: { data } }) => commit('setOrganizators', data))
      .catch((err) => commit('setOrganizators', []));
  },

  getOrganizatorsFullList({ commit }) {
    return $api
      .get('organizationlist/get')
      .then(({ data: { data } }) => commit('setOrganizatorsFullList', data))
      .catch((err) => commit('setOrganizatorsFullList', []));
  },

  getEventTypes({ commit }, organizer) {
    return $api
      .get('events/get', { params: { limit: 100, ...organizer } })
      .then(({ data: { data } }) =>
        commit(
          'setEventTypes',
          Array.isArray(data) ? data.map(({ id, name }) => ({ id, name })) : []
        )
      )
      .catch((err) => commit('setEventTypes', []));
  },

  getCompetencesList({ commit }, params) {
    return $api
      .get('competences/get', { params })
      .then(({ data: { data, filtered } }) => {
        const result = Array.isArray(data)
          ? data.map((item) => camelize(item))
          : [];
        commit('setCompetencesList', result);
        commit('setCompetencesListCount', filtered);
      })
      .catch((err) => commit('setCompetencesList', []));
  },

  getCompetencesBlocks({ commit }, params) {
    return $api
      .get('comp-blocks/mini', { params })
      .then(({ data: { data } }) => {
        const result = Array.isArray(data) ? data : [];
        commit('setCompetencesBlocks', result);
      })
      .catch((err) => commit('setCompetencesList', []));
  },

  getNokoCompetitionList({ commit }) {
    return $api
      .get('noko/competition/list', { params: { limit: 100 } })
      .then(({ data: { data } }) =>
        commit(
          'setNokoCompetitionList',
          Array.isArray(data)
            ? data.map(({ id, name, level }) => ({ id, name, level }))
            : []
        )
      )
      .catch((err) => commit('setNokoCompetitionList', []));
  },

  getQuestionnaireForm({ commit }) {
    return $api
      .get('noko/form/list')
      .then(({ data: { data } }) =>
        commit(
          'setQuestionnaireForm',
          Array.isArray(data)
            ? data.map(({ description, id, name }) => ({
                description,
                id,
                name,
              }))
            : []
        )
      )
      .catch((err) => commit('setQuestionnaireForm', []));
  },

  async getIndastries({ commit }) {
    try {
      const { data } = await dictionaryService($api).getIndastries();
      commit('setIndustries', data);
      return data;
    } catch (err) {
      commit('setIndustries', []);
    }
  },

  async getUserEduLevel({ commit }) {
    try {
      const { data } = await dictionaryService($api).getUserEduLevel();
      commit('setUserEduLevel', data);
      return data;
    } catch (err) {
      commit('setUserEduLevel', []);
    }
  },

  async getUserConsultationsTopic({ commit }) {
    try {
      const { data } = await dictionaryService($api).getConsultationsTopic();
      commit('setUserConsultationsTopic', data);
      return data;
    } catch (err) {
      commit('setUserConsultationsTopic', []);
    }
  },

  async getRegionsDict({ commit }) {
    try {
      const { data } = await dictionaryService($api).getRegions();
      commit('setRegionsDict', data);
      return data;
    } catch (err) {
      commit('setRegionsDict', []);
    }
  },

  async getEventTypesDict({ commit }) {
    try {
      const { data } = await dictionaryService($api).getBlogEventTypes();
      commit('setBlogEventsDict', data);
      return data;
    } catch (err) {
      commit('setBlogEventsDict', []);
    }
  },

  async getActivityOrderEduLevelDict({ commit }) {
    try {
      const { data } = await dictionaryService($api).getActivityOrderEduLevel();
      commit('setActivityOrderEduLevelDict', data);
      return data;
    } catch (err) {
      commit('setActivityOrderEduLevelDict', []);
    }
  },

  async getEventOrderEduLevelsDict({ commit }) {
    try {
      const { data } = await dictionaryService($api).getEventOrderEduLevels();
      commit('setEventOrderEduLevelsDict', data);
      return data;
    } catch (err) {
      commit('setEventOrderEduLevelsDict', []);
    }
  },

  async getWorkScheduleDataDict({ commit }) {
    try {
      const { data } = await dictionaryService($api).getWorkScheduleData();
      commit('setWorkScheduleDataDict', data);
      return data;
    } catch (err) {
      commit('setWorkScheduleDataDict', []);
    }
  },

  async getEmploymentDict({ commit }) {
    try {
      const { data } = await dictionaryService($api).getEmploymentData();
      commit('setEmploymentDict', data);
      return data;
    } catch (err) {
      commit('setEmploymentDict', []);
    }
  },

  async getPartnerRoleDict({ commit }) {
    try {
      const { data } = await dictionaryService($api).getPartnerRoleDictData();
      const convertData = data.map((el) => ({
        ...el,
        name: el.site_name || el.name, // типа имя брать из site_name, в сенче из name
      }));
      commit('setPartnerRoleDict', convertData);
      return data;
    } catch (err) {
      commit('setPartnerRoleDict', []);
    }
  },

  async getProfSpheres({ commit }) {
    try {
      const { data } = await dictionaryService($api).getProfSpheres();
      commit('setProfSpheres', data);
      return data;
    } catch (err) {
      commit('setProfSpheres', []);
    }
  },

  async getProfessions({ commit }) {
    try {
      const { data } = await professionsService($api).getProfessionsMini();
      commit('setProfessions', data);
      return data;
    } catch (err) {
      commit('setProfessions', []);
    }
  },

  async getCompetences({ commit }) {
    try {
      const { data } = await dictionaryService($api).getCompetences();
      commit('setCompetences', data);
      return data;
    } catch (err) {
      commit('setCompetences', []);
    }
  },

  async orderCancelReasonDict({ commit }) {
    try {
      const { data } = await dictionaryService($api).getOrderCancelReasonDict();
      commit('setOrderCancelReasonDict', data);
      return data;
    } catch (err) {
      commit('setOrderCancelReasonDict', []);
    }
  },

  async copMultiRequest({ commit }) {
    try {
      const { data } = await dictionaryService($api).getCopMultiDict();
      commit('setMultiCop', data);
      return data;
    } catch (err) {
      commit('setMultiCop', []);
    }
  },

  async organizationsRequest({ commit }) {
    try {
      const { data } = await dictionaryService($api).getOrganizationsDict();
      commit('setOrganizations', data);
      return data;
    } catch (err) {
      commit('setOrganizations', []);
    }
  },

  async getProgrammTypes({ commit }) {
    try {
      const { data } = await dictionaryService($api).getProgrammTypes();
      commit('setProgrammTypes', data);
      return data;
    } catch (err) {
      commit('setProgrammTypes', []);
    }
  },

  async getPayLevels({ commit }) {
    try {
      const { data } = await dictionaryService($api).getPayLevels();
      commit('setPayLevels', data);
      return data;
    } catch (err) {
      commit('setPayLevels', []);
    }
  },

  // Временное решение, оптимизировать, переделать
  async getUnpublishedProfSpheres({ commit }) {
    try {
      const { data } = await dictionaryService(
        $api
      ).getUnpublishedProfSpheres();
      commit('setUnpublishedProfSpheres', data);
      return data;
    } catch (err) {
      commit('setUnpublishedProfSpheres', []);
    }
  },

  async getUnpublishedProfessions({ commit }) {
    try {
      const { data } = await dictionaryService(
        $api
      ).getUnpublishedProfessions();
      commit('setUnpublishedProfessions', data);
      return data;
    } catch (err) {
      commit('setUnpublishedProfessions', []);
    }
  },

  async getUnpublishedCompetences({ commit }) {
    try {
      const { data } = await dictionaryService(
        $api
      ).getUnpublishedCompetences();
      commit('setUnpublishedCompetences', data);
      return data;
    } catch (err) {
      commit('setUnpublishedCompetences', []);
    }
  },
  // конец решения

  async getOvzDiseases({ commit }) {
    try {
      const { data } = await dictionaryService($api).getPfdodDiseases();
      commit('setPfdodDiseases', data);
      return data;
    } catch (err) {
      commit('setPfdodDiseases', []);
    }
  },

  async getActivityLevel({ commit }) {
    try {
      const { data } = await dictionaryService($api).getActivityLevel();
      commit('setActivityLevels', data);
      return data;
    } catch (err) {
      commit('setActivityLevels', []);
    }
  },

  async getActivityMember({ commit }) {
    try {
      const { data } = await dictionaryService($api).getActivityMember();
      commit('setActivityMembers', data);
      return data;
    } catch (err) {
      commit('setActivityMembers', []);
    }
  },

  async getNokoCompetitionLevels({ commit }) {
    try {
      const { data } = await dictionaryService($api).getNokoCompetitionLevels();
      commit('setNokoCompetitionLevels', data);
      return data;
    } catch (err) {
      commit('setNokoCompetitionLevels', []);
    }
  },

  async getNokoCompetitionTypes({ commit }) {
    try {
      const { data } = await dictionaryService($api).getNokoCompetitionTypes();
      commit('setNokoCompetitionTypes', data);
      return data;
    } catch (err) {
      commit('setNokoCompetitionTypes', []);
    }
  },

  async getNokoProgressResult({ commit }) {
    try {
      const { data } = await dictionaryService($api).getNokoProgressResult();
      commit('setNokoProgressResult', data);
      return data;
    } catch (err) {
      commit('setNokoProgressResult', []);
    }
  },

  async getEducationFormActivity({ commit }) {
    try {
      const { data } = await dictionaryService($api).getEducationForm();
      commit('setEducationForms', data);
      return data;
    } catch (err) {
      commit('setEducationForms', []);
    }
  },

  async getEducationModes({ commit }) {
    try {
      const { data } = await dictionaryService($api).getEducationModes();
      commit('setEducationModes', data);
      return data;
    } catch (err) {
      commit('setEducationModes', []);
    }
  },

  async getEducationCategories({ commit }) {
    try {
      const { data } = await dictionaryService($api).getEducationCategories();
      commit('setEducationCategories', data);
      return data;
    } catch (err) {
      commit('setEducationCategories', []);
    }
  },

  async getEducationForm({ commit }) {
    try {
      const { data } = await dictionaryService($api).getEducationForm();
      commit('setEducationFormData', data);
      return data;
    } catch (err) {
      commit('setEducationFormData', []);
    }
  },

  async getWorkTypes({ commit }) {
    try {
      const { data } = await dictionaryService($api).getWorkTypes();
      commit('setWorkTypesData', data);
      return data;
    } catch (err) {
      commit('setWorkTypesData', []);
    }
  },

  async getSpheresTypes({ commit }) {
    try {
      const { data } = await dictionaryService($api).getSpheresTypes();
      commit('setSpheresTypesData', data);
      return data;
    } catch (err) {
      commit('setSpheresTypesData', []);
    }
  },

  async getProfStandarts({ commit }) {
    try {
      const { data } = await dictionaryService($api).getProfStandarts();
      commit('setProfStandarts', data);
      return data;
    } catch (err) {
      commit('setProfStandarts', []);
    }
  },

  async getWorkPlaces({ commit }) {
    try {
      const { data } = await dictionaryService($api).getWorkPlaces();
      commit('setWorkPlaces', data);
      return data;
    } catch (err) {
      commit('setWorkPlaces', []);
    }
  },

  async getEducationLevels({ commit }) {
    try {
      const { data } = await dictionaryService($api).getEducationLevels();
      commit('setEducationLevels', data);
      return data;
    } catch (err) {
      commit('setEducationLevels', []);
    }
  },

  async getDriverLicenseDict({ commit }) {
    try {
      const { data } = await dictionaryService($api).getDriverLicenseDict();
      commit('setDriverLicenseDict', data);
    } catch (err) {
      commit('setDriverLicenseDict', []);
    }
  },

  async getLanguageLevelDict({ commit }) {
    try {
      const { data } = await dictionaryService($api).getLanguageLevelDict();
      commit('setLanguageLevelDict', data);
    } catch (err) {
      commit('setLanguageLevelDict', []);
    }
  },

  async getWorldLanguageDict({ commit }) {
    try {
      const { data } = await dictionaryService($api).getWorldLanguageDict();
      commit('setWorldLanguageDict', data);
    } catch (err) {
      commit('setWorldLanguageDict', []);
    }
  },

  async getEducationLevel({ commit }) {
    try {
      const { data } = await dictionaryService($api).getEducationLevelDict();
      commit('setEducationLevelDict', data);
    } catch (err) {
      commit('setEducationLevelDict', []);
    }
  },

  async getEducationType({ commit }) {
    try {
      const { data } = await dictionaryService($api).getEducationTypeDict();
      commit('setEducationTypeDict', data);
    } catch (err) {
      commit('setEducationTypeDict', []);
    }
  },
});

export default createActions;



// WEBPACK FOOTER //
// ./src/store/actions.js